import { createContext } from "react";

export type PublicPublication = {
  title: string;
  imageObjectUrl: string;
};

type ConfigContextType = {
  userPoolId: string;
  clientId: string;
  assetBucketUrl: string;
  apiUrl: string;
  mixpanelEnabled: boolean;
  msalClientId?: string;
  aiSearchApiUrl: string;
  frjDomain?: string;
  publicPublications: PublicPublication[] | null;
  loginPageContent?: string;
};

export const ConfigContext = createContext<ConfigContextType | undefined>(
  undefined,
);
